import React, { useId } from 'react';
import { Switch } from 'antd';

/**
 * THE boolean control: a row with the setting's name (14px/600) and a
 * one-line description on the left and the switch on the right, rows
 * divided by a soft line. Every on/off in the product — collection
 * settings, the card editor's element options, a
 * form's options — is one of these; there are no bare switches under a
 * label.
 *
 *   <ToggleRow label="Required" description="Items can't be saved without a value."
 *              checked={value} onChange={setValue} />
 *
 * Pass `children` to put a different control in the switch's slot (a
 * button, a select) while keeping the row's anatomy.
 */
export default function ToggleRow({
	label,
	description = null,
	checked,
	onChange,
	disabled = false,
	id,
	name,
	'aria-label': ariaLabel,
	first = false,
	className = '',
	children,
	size,
}) {
	const generatedId = useId();
	const controlId = id || `toggle-${generatedId}`;
	const classes = ['toggle-row', first ? 'toggle-row--first' : '', className].filter(Boolean).join(' ');
	return (
		<div className={classes}>
			<div className="toggle-row__text">
				<label htmlFor={children ? undefined : controlId} className="toggle-row__label">{label}</label>
				{description ? <span className="toggle-row__description">{description}</span> : null}
			</div>
			{children !== undefined ? children : (
				<Switch
					id={controlId}
					name={name}
					checked={Boolean(checked)}
					onChange={onChange}
					disabled={disabled}
					aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
					size={size}
				/>
			)}
		</div>
	);
}
